export default __webpack_public_path__ + "static/media/review-2.8e626413.jpg";